import UntypedContentDivider from './ContentDivider';

const ContentDivider = UntypedContentDivider as any;

export default ContentDivider;
